const ctaTitleOptions = [
  'Check Availability',
  'Inquire Now',
  'Learn More',
  'None',
  'Other',
].map(opt => ({ id: opt, name: opt }));

export default ctaTitleOptions;
